import React from "react";
import { Modal } from "antd";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { useSelector } from "react-redux";
import { Input } from "antd";

import StatusImg from "../../assets/images/completed_status.svg";
import { SubmitButton } from "../CustomFields";
import { responsive } from "../../utils/style";
import {
  HEIGHT_FOR_AGE_OPTIONS,
  WEIGHT_FOR_HEIGHT_OPTIONS,
} from "../../utils/nutrition";

const ConfirmModal = ({ onCancel, visible, onSubmit, event, formValues }) => {
  const nutritionState = useSelector((state) => state.nutrition);

  return (
    <StyledModal closable={false} footer={null} visible={visible}>
      {nutritionState.isCompleted ? (
        <>
          <Image src={StatusImg} />
          <TopicConfirm>บันทึกข้อมูลภาวะโภชนาการ</TopicConfirm>
          <Remark>
            บันทึกข้อมูลภาวะโภชนาการ
            <br />
            ครั้งที่ {event} เรียบร้อยแล้ว
          </Remark>
        </>
      ) : (
        <>
          <TopicConfirm>บันทึกข้อมูลภาวะโภชนาการ</TopicConfirm>
          <Remark>
            ยืนยันการบันทึกข้อมูลหรือไม่ <br />
            หากยืนยันแล้วจะไม่สามารถ <br />
            กลับมาแก้ไขได้
          </Remark>
          <Values>
            <Item>
              <Label>น้ำหนัก (กิโลกรัม)</Label>
              <Input value={`${formValues.weight} กิโลกรัม`} disabled />
            </Item>
            <Item>
              <Label>ส่วนสูง (เซนติเมตร)</Label>
              <Input value={`${formValues.height} เซนติเมตร`} disabled />
            </Item>
            {formValues.heightForAge && (
              <Item>
                <Label>ผลการประเมินส่วนสูง</Label>
                <Input
                  value={`${
                    HEIGHT_FOR_AGE_OPTIONS.find(
                      (d) => d.value === formValues.heightForAge
                    )?.label
                  }`}
                  disabled
                />
              </Item>
            )}
            {formValues.weightForHeight && (
              <Item>
                <Label>ผลการประเมินน้ำหนักตัว</Label>
                <Input
                  value={`${
                    WEIGHT_FOR_HEIGHT_OPTIONS.find(
                      (d) => d.value === formValues.weightForHeight
                    )?.label
                  }`}
                  disabled
                />
              </Item>
            )}
          </Values>
          <SubmitButton onClick={onSubmit}>ยืนยัน</SubmitButton>
          <CancelBtn onClick={onCancel}>กลับไปแก้ไข</CancelBtn>
        </>
      )}
    </StyledModal>
  );
};

export default ConfirmModal;

const TopicConfirm = styled.h5`
  font-family: Noto Sans Thai, Noto Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  color: #058459;
  margin-bottom: 4px;
`;
const Remark = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  text-align: center;
  color: #4b5768;
  margin-bottom: 16px;
`;
const CancelBtn = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  text-decoration-line: underline;
  color: #058459;
  margin-top: 16px;

  &:hover {
    cursor: pointer;
  }
`;
const StyledModal = styled(Modal)`
  font-family: Noto Sans Thai, Noto Sans;
  .ant-modal-content {
    border-radius: 8px;

    .ant-modal-body {
      padding: 36px 32px;
      text-align: center;
    }
  }
`;
const Image = styled.img`
  margin-bottom: 16px;
  width: 144px;
  height: 144px;
`;
const Values = styled.div``;
const Item = styled.div`
  text-align: left;

  input {
    border-radius: 4px;
    height: 52px;
    font-size: 18px;
    margin-bottom: 24px;

    ${responsive.mobile(css`
      margin-bottom: 16px;
    `)}
  }
`;
const Label = styled.label`
  font-size: 18px;
  line-height: 26px;
`;
